export default "__VITE_ASSET__BayLs5Xi__"